/** Current respondent signing confirmation and evidence contract version. */
export const SIGNING_CONSENT_VERSION = 1 as const;

/** Server-owned statement shown before the respondent completes signing. */
export const SIGNING_CONSENT_STATEMENT =
  'I confirm this signature is mine and agree to sign this completed response electronically.';

/** Explicit confirmation bound to one exact completed response revision. */
export interface SignatureConfirmation {
  version: typeof SIGNING_CONSENT_VERSION;
  accepted: true;
  responseRevision: number;
}

/** Safe signing lifecycle projected to the respondent. */
export type RespondentSigningState =
  | {
      status: 'required';
      version: typeof SIGNING_CONSENT_VERSION;
      statement: typeof SIGNING_CONSENT_STATEMENT;
      responseRevision: number;
    }
  | {
      status: 'signed';
      version: typeof SIGNING_CONSENT_VERSION;
    };
